<template>
  <div class="page-content">
    <slot></slot>
  </div>
</template>

<style scoped>

  .page-content {
    flex: 1;

    position: relative;
  }

</style>